import { actions as segmentioActions } from '@saucelabs/sl-util-segmentio';

export const PRODUCT_AREA = 'Billing';
export const PRODUCT_SUB_AREAS = Object.freeze({
  CHECKOUT: 'Checkout',
  CANCELLATION: 'Cancel subscription',
  PLANS: 'Plans',
  NUDGE_MODAL: 'Annual Nudge Modal',
});
export const SUBJECT = Object.freeze({
  APPLY_COUPON: 'Apply Coupon',
  CHANGE_SUBSCRIPTION_STATE: 'Change Subscription State',
  ORDER_FAILED: 'Order Failed',
  ORDER_SUCCESS: 'Order Success',
  PREVIEW_FAILED: 'Preview Failed',
  PREVIEW_SUCCESS: 'Preview Success',
  RESET_COUPON: 'Reset Coupon',
  RESET_ORDER: 'Reset Order',
  SHOW_CANCELLATION_SURVEY_MODAL: 'Show The Cancellation Survey',
  HIDE_SURVEY_MODAL: 'Hide The Cancellation Survey',
  CONFIRM_CANCELLATION: 'Confirm to Cancel the Subscription',
  NUDGE_MODAL_VIEW: 'View Nudge Modal',
  NUDGE_MODAL_CONFIRM: 'Swap to Annual',
  NUDGE_MODAL_CANCEL: 'Keep to Monthly',
});

export const EVENTS = Object.freeze({
  BILLING_INFO_CARD_CHECK: 'Billing - Billing Information - Check Credit Card',
  BILLING_INFO_CONFIRM_UPDATE: 'Billing - Billing Information - Update information',
  BILLING_INFO_REPLACE_CARD: 'Billing - Billing Information - Replace existing card',
  BILLING_INFO_UPDATE_FORM_FIELD: 'Billing - Billing Information - Update form field',
  CANCEL_ABORT_FORM: 'Billing - Cancellation - Cancel out of flow',
  CANCEL_SELECTED_PRODUCT: 'Billing - Cancellation - Select product',
  CANCEL_SUBMIT_FORM: 'Billing - Cancellation - Confirm cancellation',
  CANCEL_SUBSCRIPTION_CLICK_BUTTON: 'Billing - Start cancellation flow',
  CHECKOUT_ATTEMPT_ORDER: 'Billing - Checkout - Attempt order',
  CHECKOUT_CARD_CHECK: 'Billing - Checkout - Check Credit Card',
  CHECKOUT_LOAD_PAGE: 'Billing - Checkout - Load page',
  CHECKOUT_PREVIEW: 'Billing - Checkout - Preview',
  CHECKOUT_REPLACE_CARD: 'Billing - Checkout - Replace existing card',
  CHECKOUT_SUCCESS_PAGE: 'Billing - Checkout - Success page',
  CHECKOUT_UPDATE_FORM_FIELD: 'Billing - Checkout - Update form field',
  CONCURRENCY_PLANS_EMPTY_VISIT: 'Billing - Concurrency Plans - Load empty state',
  CONTACT_OSS: 'Billing - Plans - Navigate to Open source',
  CONTACT_SALES: 'Billing - Checkout - Select contact sales',
  NAVIGATION_CLICK_BILLING_INFO: 'Billing - Navigate to Billing Information',
  NAVIGATION_CLICK_INVOICES: 'Billing - Navigate to Invoices',
  PLANS_ADD_ADDITIONAL_PLAN: 'Billing - Subscription - Add additional plan',
  PLANS_ADD_PRODUCT: 'Billing - Plans - Add product',
  PLANS_CHANGE_PARALLEL: 'Billing - Plans - Change parallel tests',
  PLANS_CLICK_UPDATE_BUTTON: 'Billing - Update plan',
  PLANS_CONTINUE: 'Billing - Plans - Navigate continue',
  PLANS_EMPTY_VISIT: 'Billing - Plans - Load empty state',
  PLANS_NAVIGATE_BACK: 'Billing - Checkout - Navigate back',
  PLANS_SEE_ALL: 'Billing - Plans - See all',
  PLANS_SELECT_TAB: 'Billing - Plans - Select tab',
  USAGE_PLANS_EMPTY_VISIT: 'Billing - Usage Plans - Load empty state',
  USAGE_PLANS_SELECT_BLOCKS: 'Billing - Usage Plans - Select credit blocks',
  USAGE_PLANS_REQUEST_CHANGE: 'Billing - Usage Plans - Request change',
  USAGE_PLANS_REQUEST_CANCEL: 'Billing - Usage Plans - Request cancel',
});

export const VARIANT_OLD_CHECKOUT = Object.freeze({ variant: 'old' });
export const VARIANT_TWO_STEP_CHECKOUT = Object.freeze({ variant: 'two-step' });

export const MODE_CONCURRENCY = Object.freeze({ billingMode: 'concurrency' });
export const MODE_USAGE = Object.freeze({ billingMode: 'usage' });

export const trackEvent = segmentioActions.recordTrack;

export default trackEvent;
